import * as Yup from 'yup'
import { defineMessages, IntlShape } from 'react-intl'
import { IBusinessClientCreditsFormValues } from 'features/BusinessClients/types'
const messages = defineMessages({
  required: {
    id: 'validation.required',
    defaultMessage: 'Required'
  }
})
export const schema = (intl: IntlShape): Yup.SchemaOf<IBusinessClientCreditsFormValues> =>
  Yup.object().shape({
    name: Yup.string(),
    file: Yup.string(),
    amount: Yup.string().required(intl.formatMessage(messages.required))
  })
